import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NotificationService,
  LookupService
} from '../../../services/index';
import { ValidationPartialComponent } from './validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-car-search-partial',
    templateUrl: './car-search-partial.component.html',
    standalone: true,
    imports: [MatFormFieldModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatInputModule, MatAutocompleteModule, MatAutocompleteModule, NgFor, MatOptionModule, MatOptionModule, ValidationPartialComponent]
})
export class CarSearchPartialComponent implements OnInit {

  @Input() public formGroup: UntypedFormGroup;
  @Input() public fieldName: string;
  @Output() public selectedCarModelData = new EventEmitter<any>();
  public filteredCars: any;

  constructor (private notificationService: NotificationService,
    private lookupService: LookupService) {
  }

  ngOnInit() {
  }

  findVehicle() {
    this.lookupService.carLookup(this.formGroup.get(this.fieldName).value)
      .subscribe(result => {
        this.filteredCars = (result.data) ? result.data : [];
      });
  }

  updateSelectedCarModel(car) {
    console.log('[updateSelectedCarModel]', car);
    this.selectedCarModelData.emit(car);

    // console.log('[data]', this.filteredCars);
    // this.filteredCars.forEach(carData => {
    //   if(carData.id === id) {
    //     this.formGroup.get(this.fieldName).patchValue(carData.text);
    //     console.log('car data', carData);
    //     this.selectedCarModelData.emit(carData);
    //   }
    // });
  }

  displayCarName(car) {

    return (car) ? car.text : '';
  }
}
